var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('intro'),_c('priced-to-go',{attrs:{"title":'selling'}}),_c('get-started-rent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }